import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const enachApi = createApi({
  reducerPath: 'enachApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/v2/api/',
  }),
  endpoints: (builder) => ({
    enachStatus: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          secret: data.scrt,
          jwt_token: data.jwt_token,
        },
        body: new URLSearchParams({
          mode: 'check_status',
          checksum: generateChecksum({ mode: 'check_status' })
        }).toString(),
      }),
    }),
  }),
});

export const { useEnachStatusMutation } = enachApi;
